module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_8-1be916fdc2e3b5ba8a82cb097dc4a6ce.jpg";